import { Skeleton } from "@chakra-ui/react";
import type { SkeletonProps } from "@chakra-ui/react";
import { ReactNode } from "react";

interface SkeletonBaseProps extends SkeletonProps {
	children?: ReactNode;
	height?: string | number;
	startColor?: string;
	width?: string | number;
}

export const SkeletonBase: React.FC<SkeletonBaseProps> = ({
	children,
	width = "128px",
	height = "24px",
	startColor = "lightgray",
	...props
}) => {
	return (
		<Skeleton
			{...props}
			width={width}
			height={height}
			startColor={startColor}
		>
			{children}
		</Skeleton>
	);
};
